import Head from "next/head";
import Link from "next/link";
import { Button } from "@/components/Button";
import { ExternalLinkIcon } from "@heroicons/react/outline";
import { Layout } from "@/components/Layout";
import { PageTitle } from "@/components/PageTitle";
import { SectionContainer } from "@/components/SectionContainer";
import { useRouter } from "next/router";
import { stringify } from "querystring";

export default function DonateNonPolitical() {
  const pageTitle = "Donate to Govern For California";
  const router = useRouter();

  // if a query string is provided, append it to the Credit Card and Appreciated
  // securities links (for EveryAction optimized ask amounts and conversion)
  const queryString =
    Object.keys(router.query).length > 0 ? `?${stringify(router.query)}` : "";

  const non_political_tiers = [
    {
      name: "Credit Card",
      href: `https://action.governforcalifornia.org/a/donate_to_c4${queryString}`,
      target: "_blank",
      description: "",
      buttonText: "Donate",
    },
    // {
    //   name: "PayPal",
    //   href: "https://action.governforcalifornia.org/a/donate_to_c4_paypal",
    //   target: "_blank",
    //   description: "",
    //   buttonText: "Donate",
    // },
    {
      name: "Check or Wire Transfer",
      href: "https://drive.google.com/file/d/1dsuDIQGovehMYtZbwjPU7vs4_c1KPhBw/view?usp=sharing",
      target: "_blank",
      description: "",
      buttonText: "Donate",
    },
    {
      name: "Appreciated Securities",
      href: `https://action.governforcalifornia.org/a/donate-appreciated-securities${queryString}`,
      target: "_blank",
      description: "via Stock Transfer",
      buttonText: "Donate",
    },
    {
      name: "Crypto",
      href: "https://bitpay.com/478803/donate",
      target: "_blank",
      description: "via BitPay",
      buttonText: "Donate",
    },
  ];

  return (
    <>
      <Head>
        <title>{`${pageTitle} - Govern For California`}</title>
        <meta name="description" content="Donate to Govern For California." />
      </Head>
      <Layout mobileTitle="Donate to GFC">
        <PageTitle title={pageTitle} />
        <SectionContainer bgColor={"bg-white"}>
          {/* <div className="sm:align-center mb-12 sm:my-6 sm:flex sm:flex-col">
            <div className="relative flex rounded-lg bg-brand-light p-0.5 sm:self-center lg:self-start ">
              <Link
                href="/donate/501c4"
                type="button"
                className="relative w-1/2 whitespace-nowrap rounded-md border-gray-100 bg-gray-50 py-2 text-center text-xs font-medium text-gray-900 drop-shadow-xl focus:z-10 focus:outline-none focus:ring-2 focus:ring-brand-button sm:w-auto sm:px-8 sm:text-sm"
              >
                501(c)(4)
              </Link>
              <Link
                href="/donate/political"
                type="button"
                className="relative ml-0.5 w-1/2 whitespace-nowrap rounded-md border border-transparent py-2 text-center text-xs font-medium text-gray-900 focus:z-10 focus:outline-none focus:ring-2 focus:ring-brand-button sm:w-auto sm:px-8 sm:text-sm"
              >
                Political
              </Link>
            </div>
          </div> */}
          <div className="sm:mt-6">
            <p className="text-lg font-medium text-gray-800">
              Donations are not publicly reported or subject to pay-to-play
              restrictions and there are no minimum or maximum amounts.
            </p>
            <div className="mt-6 items-center sm:flex sm:justify-center lg:justify-start">
              <div className="items-center text-center">
                <Button
                  variant="outline"
                  href="https://action.governforcalifornia.org/a/donate_to_c4?SelectedFrequency=4"
                  target="_blank"
                  rel="noreferrer"
                >
                  Donate monthly, quarterly or yearly
                  <ExternalLinkIcon
                    className="ml-[3px] mt-[6px] h-3"
                    aria-hidden="true"
                  />
                </Button>
              </div>
            </div>
            <div className="mt-6 space-y-4 sm:mx-auto sm:grid sm:grid-cols-4 sm:gap-6 sm:space-y-0 lg:mx-0  xl:mx-0">
              {non_political_tiers.map((tier) => (
                <div
                  key={tier.name}
                  className="divide-y divide-gray-200 rounded-lg border border-gray-200 shadow-sm"
                >
                  <div className="p-6">
                    <div className="sm:h-24">
                      <h2 className="text-base font-medium leading-6 text-gray-900">
                        {tier.name}
                      </h2>
                      <p className="mt-4 text-sm text-gray-500 md:min-h-[50px]">
                        {tier.name === "Crypto" ? (
                          <>
                            via{" "}
                            <svg
                              className="inline"
                              width="55px"
                              viewBox="0 0 89 32"
                              version="1.1"
                              xmlns="http://www.w3.org/2000/svg"
                              xmlnsXlink="http://www.w3.org/1999/xlink"
                              aria-hidden="true"
                              focusable="false"
                            >
                              <g
                                id="Symbols"
                                stroke="none"
                                strokeWidth="1"
                                fill="none"
                                fillRule="evenodd"
                              >
                                <g
                                  id="Navigation-(Desktop)/Main-Menu-(blue)"
                                  transform="translate(-44.000000, -26.000000)"
                                  fill="#1A3B8B"
                                >
                                  <g id="Header/Top">
                                    <g
                                      id="bitpay-logo-primary"
                                      transform="translate(44.000000, 26.000000)"
                                    >
                                      <path
                                        d="M89,8.04715128 L84.370064,8.04715128 L81.6908117,19.3870334 L81.3147762,20.9430255 C81.0562519,21.0137525 80.7977276,21.0844794 80.5392032,21.1316306 C80.0691589,21.2259332 79.5756125,21.2730845 79.0585638,21.2730845 C78.4710084,21.2730845 78.0009642,21.1787819 77.648431,21.0137525 C77.3194,20.848723 77.0608756,20.6129666 76.9198624,20.2829077 C76.7788491,19.9764244 76.7318446,19.5992141 76.7553469,19.1748527 C76.7788491,18.7504912 76.8728579,18.2789784 76.990369,17.8074656 L78.4005018,11.913556 L79.3170881,8 L74.5931432,8 L72.4544418,17.0530452 C72.1959175,18.1375246 72.0549042,19.1748527 72.0078998,20.1650295 C71.9608953,21.1552063 72.1254108,22.0039293 72.4544418,22.7819253 C72.7834728,23.5363458 73.3710281,24.1257367 74.1701034,24.5736739 C74.9691787,25.021611 76.1207871,25.2337917 77.5779243,25.2337917 C78.5885195,25.2337917 79.4816036,25.1394892 80.2336744,24.9744597 C80.2571766,24.9744597 80.3041811,24.9508841 80.3276833,24.9508841 L80.3276833,24.9508841 C80.1161634,25.8939096 79.6931235,26.6483301 79.0350616,27.237721 C78.3534974,27.827112 77.3664044,28.1335953 76.0502805,28.1335953 C75.4862273,28.1335953 74.9691787,28.1100196 74.4991344,28.0392927 L73.5825481,31.8821218 C74.1936056,31.9528487 74.8751698,32 75.6272406,32 C77.0373734,32 78.2594885,31.8349705 79.3170881,31.5284872 C80.3746877,31.1984283 81.2677718,30.7269155 82.0433449,30.0667976 C82.7954157,29.4066798 83.4299754,28.5815324 83.9470241,27.6149312 C84.4640728,26.6247544 84.8636105,25.4695481 85.1691392,24.1021611 L88.3654402,10.6168959 L88.3654402,10.6168959 L89,8.04715128 L89,8.04715128 Z"
                                        id="y_2_"
                                      ></path>
                                      <path
                                        d="M68.8140845,17.5945205 C68.543662,18.7589041 68.4535211,19.9465753 68.5661972,21.1109589 C68.6788732,22.2986301 69.1295775,24.0917808 69.5577465,25 L65.2760563,25 C64.7577465,24.0917808 64.7802817,23.6493151 64.6676056,23.369863 C64.1042254,23.8356164 63.4957746,24.2315068 62.8197183,24.5342466 C62.143662,24.8369863 61.4,25 60.543662,25 C59.5521127,25 58.6957746,24.8136986 57.9971831,24.4643836 C57.2985915,24.1150685 56.7126761,23.6260274 56.2619718,23.0205479 C55.8112676,22.4150685 55.4957746,21.7164384 55.2929577,20.9013699 C55.0901408,20.0863014 55,19.2246575 55,18.2931507 C55,16.8726027 55.2478873,15.5452055 55.7211268,14.2876712 C56.2169014,13.030137 56.8929577,11.9356164 57.7492958,11.0041096 C58.6056338,10.0726027 60.7014085,8 64.1267606,8 L71,8 L68.8140845,17.5945205 L68.8140845,17.5945205 Z M65.6816901,11.8890411 C63.6084507,11.8890411 63.2253521,11.8890411 62.3690141,12.3315068 C61.7605634,12.6575342 61.2647887,13.1465753 60.8366197,13.7054795 C60.4084507,14.2643836 60.0478873,14.9164384 59.8,15.6616438 C59.5521127,16.4068493 59.4169014,17.1753425 59.4169014,17.9671233 C59.4169014,18.9452055 59.5746479,19.7369863 59.8901408,20.3191781 C60.2056338,20.9013699 60.7915493,21.1808219 61.6478873,21.1808219 C62.0985915,21.1808219 62.5267606,21.0876712 62.8873239,20.9013699 C63.2478873,20.7150685 63.6535211,20.4123288 64.0591549,19.969863 C64.1042254,19.4575342 64.171831,18.9219178 64.2619718,18.3630137 C64.3521127,17.8041096 64.4647887,17.2684932 64.5549296,16.8027397 L65.6816901,11.8890411 L65.6816901,11.8890411 Z"
                                        id="a_2_"
                                      ></path>
                                      <path
                                        d="M54,14.8856549 C54,16.4397089 53.7451737,17.8503119 53.2586873,19.1413721 C52.7722008,20.4324324 52.0772201,21.5322245 51.1969112,22.464657 C50.3166023,23.3970894 49.2741313,24.1143451 48.046332,24.6403326 C46.8185328,25.1663202 45.4980695,25.4293139 44.0617761,25.4293139 C43.3667954,25.4293139 42.6718147,25.3575884 41.953668,25.2380457 L40.5637066,31 L36,31 L41.3050193,8 L47.3976834,8 C48.5559846,8 49.5521236,8.19126819 50.3629344,8.54989605 C51.1969112,8.90852391 51.8687259,9.41060291 52.4247104,10.0322245 C52.957529,10.6538462 53.3513514,11.3950104 53.6061776,12.2318087 C53.8841699,13.0446985 54,13.9293139 54,14.8856549 L54,14.8856549 Z M42.8108108,21.4126819 C43.1583012,21.508316 43.5984556,21.5322245 44.1081081,21.5322245 C44.9189189,21.5322245 45.6370656,21.3887734 46.3088803,21.0779626 C46.957529,20.7671518 47.5366795,20.3367983 48,19.7869023 C48.4633205,19.2370062 48.8108108,18.5675676 49.0888031,17.8024948 C49.3436293,17.037422 49.4826255,16.1767152 49.4826255,15.2442827 C49.4826255,14.3357588 49.2972973,13.5467775 48.9034749,12.9251559 C48.5096525,12.2796258 47.8378378,11.9449064 46.8648649,11.9449064 L45.0579151,11.9449064 L42.8108108,21.4126819 L42.8108108,21.4126819 Z"
                                        id="p_2_"
                                      ></path>
                                      <path
                                        d="M33.2447374,21.0530786 C32.6376422,21.0530786 32.151966,20.9596603 31.7877089,20.7961783 C31.4477356,20.6326964 31.1806137,20.3991507 31.0349108,20.0721868 C30.889208,19.7685775 30.8406404,19.3949045 30.8649242,18.9745223 C30.889208,18.5541401 30.9863432,18.0870488 31.1077623,17.6199575 L32.5647908,11.7813163 L38.0043639,11.7813163 L39,7.9044586 L33.5361431,7.9044586 L34.7989011,3 L29.6993014,3.77070064 L26.4695549,16.895966 C26.202433,17.970276 26.0567301,18.9978769 26.0081625,19.9787686 C25.9595949,20.9596603 26.1295815,21.8004246 26.4695549,22.5711253 C26.8095282,23.3184713 27.4166234,23.9023355 28.2422729,24.3460722 C29.0679224,24.7898089 30.257829,25 31.7634251,25 C32.8076289,25 33.7304136,24.9065817 34.5074954,24.7430998 C34.5803469,24.7197452 34.7017659,24.6963907 34.7746173,24.6730361 L35.7702535,20.6794055 C35.4302802,20.7961783 35.0903068,20.866242 34.7746173,20.9129512 C34.2889412,21.0063694 33.7789812,21.0530786 33.2447374,21.0530786 L33.2447374,21.0530786 Z"
                                        id="t_2_"
                                      ></path>
                                      <polygon
                                        id="i_bottom_6_"
                                        points="21.2324324 8 17 25 21.7918919 25 26 8"
                                      ></polygon>
                                      <polygon
                                        id="i_top_2_"
                                        points="26.339207 6 27 3 22.660793 3 22 6"
                                      ></polygon>
                                      <path
                                        d="M10.4180791,7.55258126 C11.3672316,7.55258126 12.2033898,7.74378585 12.9039548,8.10229446 C13.6045198,8.46080306 14.1694915,8.93881453 14.6440678,9.56022945 C15.0960452,10.1816444 15.4350282,10.8986616 15.6610169,11.7112811 C15.8870056,12.5239006 16,13.4082218 16,14.3642447 C16,15.8221797 15.7514124,17.1845124 15.2316384,18.499044 C14.7118644,19.789675 14.0338983,20.9369025 13.1525424,21.8929254 C12.2711864,22.8489484 11.2316384,23.6137667 10.0338983,24.1634799 C8.83615819,24.7131931 7.5480226,25 6.14689266,25 C5.96610169,25 5.64971751,25 5.19774011,24.9760994 C4.74576271,24.9760994 4.2259887,24.9282983 3.66101695,24.832696 C3.07344633,24.7370937 2.46327684,24.6175908 1.83050847,24.4502868 C1.17514124,24.2829828 0.564971751,24.0439771 1.77635684e-15,23.7571702 L5.17514124,0.764818356 L9.8079096,0 L7.97740113,8.1500956 C8.38418079,7.95889101 8.74576271,7.81548757 9.15254237,7.71988528 C9.53672316,7.60038241 9.96610169,7.55258126 10.4180791,7.55258126 L10.4180791,7.55258126 Z M6.53107345,21.0803059 C7.23163842,21.0803059 7.88700565,20.9130019 8.49717514,20.5305927 C9.10734463,20.1720841 9.64971751,19.6940727 10.1016949,19.0965583 C10.5536723,18.499044 10.9152542,17.8059273 11.1638418,17.0650096 C11.4124294,16.3001912 11.5480226,15.5114723 11.5480226,14.6988528 C11.5480226,13.6950287 11.3898305,12.9063098 11.0734463,12.332696 C10.7570621,11.7590822 10.1016949,11.4961759 9.24293785,11.4961759 C8.97175141,11.4961759 8.6779661,11.5200765 8.2259887,11.6395793 C7.7740113,11.7351816 7.38983051,11.9741874 7.02824859,12.3087954 L5.08474576,20.9847036 C5.67231638,21.0803059 5.85310734,21.1042065 6.01129944,21.1042065 C6.12429379,21.0803059 6.30508475,21.0803059 6.53107345,21.0803059 L6.53107345,21.0803059 Z"
                                        id="b_2_"
                                      ></path>
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </svg>
                          </>
                        ) : (
                          <>{tier.description}</>
                        )}
                      </p>
                      {/* <p className="mt-8">
                      <span className="text-4xl font-extrabold text-gray-900"
                        >${{ tier.priceMonthly }}</span
                      >
                      {{ ' ' }}
                      <span className="text-base font-medium text-gray-500">/mo</span>
                    </p> */}
                    </div>
                    <a
                      href={tier.href}
                      target={tier.target}
                      className="mt-8 block w-full rounded-md border border-gray-800 bg-gray-800 py-2 text-center text-sm font-semibold text-white hover:bg-gray-900"
                    >
                      {tier.buttonText}
                      {tier.target === "_blank" && (
                        <ExternalLinkIcon
                          className="-mr-1 ml-[3px] inline h-3"
                          aria-hidden="true"
                        />
                      )}
                    </a>
                  </div>
                  {/* <div className="px-6 pt-6 pb-8">
                  <h3
                    className="text-xs font-medium uppercase tracking-wide text-gray-900"
                  >
                    What's included
                  </h3>
                  <ul role="list" className="mt-6 space-y-4">
                    <li
                      v-for="feature in tier.includedFeatures"
                      :key="feature"
                      className="flex space-x-3"
                    >
                      <CheckIcon
                        className="h-5 w-5 flex-shrink-0 text-green-500"
                        aria-hidden="true"
                      />
                      <span className="text-sm text-gray-500">{{ feature }}</span>
                    </li>
                  </ul>
                </div> */}
                </div>
              ))}
            </div>
            {/* <div className="sm:align-center sm:flex sm:flex-col">
              <p className="mt-12 text-sm text-gray-500">
                <sup>*</sup>Donations to GFC 501(c)(4) are not publicly
                reported, there are no minimum or maximum amounts, and there are
                no pay-to-play restrictions. Donations are not tax-deductible as
                charitable contributions for federal income tax purposes.
              </p>
            </div> */}
          </div>
          <div className="sm:align-center sm:flex sm:flex-col">
            <p className="mt-2 text-sm text-gray-500">
              Please{" "}
              <Link href="/contact" className="body-link">
                contact us
              </Link>
              &nbsp;with any questions.
            </p>
          </div>
        </SectionContainer>
      </Layout>
    </>
  );
}
